import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsRolesRoleRoute extends Route {
  @service declare store: StoreService;

  model({ role_id }: { role_id: string }) {
    return this.store.findRecord('role', role_id);
  }
}

export default instrumentRoutePerformance(SettingsRolesRoleRoute);
